import handleBulletShifting from './plugins/handleBulletShifting';
import hasBullet from './plugins/hasBullet';
import convertToBullet from './plugins/convertToBullet';
import renderDict from '../../editResume/EditSpace/EditorPane/RenderContent/EditorSection/utils/renderDict';

const handleClickBlock = (editor) => {
  if (editor) {
    const {
      anchorBlock,
      focusBlock,
      document,
      selection: { isExpanded },
    } = editor.value;
    const { key: focusBlockKey } = focusBlock;
    const parent = document.getParent(focusBlockKey);
    const { type: parentType } = parent;
    const isListItem = hasBullet(editor);
    if (
      parentType !== 'objective' &&
      (isListItem ||
        renderDict[parentType] === 'organization_role_editable_div')
    ) {
      if (isExpanded && anchorBlock.key !== focusBlock.key) {
        const paraBlocks = editor.value.document
          .getLeafBlocksAtRange(editor.value.selection)
          .toArray();
        let nonListItemPresent;
        paraBlocks.forEach((paraBlock) => {
          const { type: paraParentType } = editor.value.document.getParent(
            paraBlock.key,
          );
          if (renderDict[paraParentType] === 'organization_role_editable_div') {
            const prevSibling = editor.value.document.getPreviousSibling(
              paraBlock.key,
            );
            const nextSibling = editor.value.document.getNextSibling(
              paraBlock.key,
            );

            if (prevSibling && prevSibling.type === 'unordered_list') {
              editor.wrapBlockByKey(paraBlock.key, 'list_item');
              const requiredLi = editor.value.document.getParent(paraBlock.key);
              editor.moveNodeByKey(
                requiredLi.key,
                prevSibling.key,
                prevSibling.nodes.size,
              );

              if (nextSibling && nextSibling.type === 'unordered_list') {
                nextSibling.nodes.toArray().forEach((nextSiblingChild, i) => {
                  editor.moveNodeByKey(
                    nextSiblingChild.key,
                    prevSibling.key,
                    prevSibling.nodes.size + i + 1,
                  );
                });
              }

              if (!nonListItemPresent) nonListItemPresent = true;
            } else if (nextSibling && nextSibling.type === 'unordered_list') {
              editor.wrapBlockByKey(paraBlock.key, 'list_item');
              const requiredLi = editor.value.document.getParent(paraBlock.key);
              editor.moveNodeByKey(requiredLi.key, nextSibling.key, 0);

              if (!nonListItemPresent) nonListItemPresent = true;
            } else {
              editor.wrapBlockByKey(paraBlock.key, 'list_item');

              const wrappedListItem = editor.value.document.getParent(
                paraBlock.key,
              );
              editor.wrapBlockByKey(wrappedListItem.key, 'unordered_list');
              nonListItemPresent = true;
            }
          }
        });

        if (nonListItemPresent) return true;

        /**
         * Only bullets exist
         */
        const initialDoc = editor.value.document;
        const prevSiblingNewIndices = {};
        paraBlocks.forEach((paraBlock, index) => {
          handleBulletShifting(
            editor,
            true,
            paraBlock,
            index,
            paraBlocks,
            prevSiblingNewIndices,
            initialDoc,
          );
          return true;
        });

        // if (!isListItem) convertToBullet(editor);
        // else handleBulletShifting(editor, true);
      } else if (isListItem) {
        handleBulletShifting(
          editor,
          true,
          focusBlock,
          null,
          null,
          null,
          editor.value.document,
        );
      } else if (!isListItem) convertToBullet(editor);
    }
  }
  return false;
};

export default handleClickBlock;
